/*
 * @Author: 肖玲
 * @Date: 2023-05-15 11:04:46
 * @LastEditTime: 2023-05-15 11:13:37
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-policy-management\index.js
 * 费用政策管理
 */
import policyFilingMaintenanceRouter from './modules/policyFilingMaintenance.js'
const costPolicyManagementRouter = [].concat(policyFilingMaintenanceRouter)

export default costPolicyManagementRouter
